// extracted by mini-css-extract-plugin
export default {"cls1":"Content-Grid_cls1__t6XGi","cls2":"Content-Grid_cls2__VHo3j Content-Grid_cls1__t6XGi"};